import { render, staticRenderFns } from "./imageCard.vue?vue&type=template&id=8c2b068e&scoped=true&"
import script from "./imageCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./imageCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./imageCard.vue?vue&type=style&index=0&id=8c2b068e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2b068e",
  null
  
)

export default component.exports